module.exports = __webpack_public_path__ + "img/lock-route.f6cfb1be.svg";